<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="stallinfo" :rules="rules" ref="stallrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="所属商家" prop="owenbusiness">
					    <el-select style="width: 100%;" v-model="stallinfo.owenbusiness" placeholder="请选择商家">
							<el-option v-for="item in businesses" :key="item.entry_business_id" :label="item.entry_business_name" :value="item.entry_business_id"> </el-option>
					    </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="档口名称" prop="name">
						<el-input clearable v-model="stallinfo.name" maxlength="50"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="档口编码" prop="code">
						<el-input clearable v-model="stallinfo.code" maxlength="10"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="联系人" prop="contactname">
						<el-input clearable v-model="stallinfo.contactname" maxlength="20"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="联系电话" prop="telphone">
						<el-input clearable v-model="stallinfo.telphone" maxlength="11"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="商铺位置" prop="address" >
						<el-input clearable v-model="stallinfo.address" maxlength="100"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="抽成比例" prop="drawproportion">
						<el-input-number style="width: 100%;" v-model="stallinfo.drawproportion" :precision="2" :min="0.1" :max="1" :step="0.1" label="抽成比例"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveStalls">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { getStallDetail,addNewStall, editStall } from '/static/apiUrl.js'
	export default {
		name : 'StallDetail',
		data() {
			return {
				editok : false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},				
				stallinfo : {
					"id": "",
					"name": "",
					"code": "",
					"contactname": "",
					"telphone": "",
					"address": "",
					"drawproportion": 0,
					"state": "",
					"owenbusiness": "",
				},			
				rules:{
					name: [
						{ required: true, message: '请输入档口名称', trigger: 'blur' }
					],
					owenbusiness: [
						{ required: true, message: '请选择所属商家', trigger: 'blur' }
					],
					drawproportion : [
						{ required: true, message: '请输入抽成比例', trigger: 'blur'},
						{ type: 'number', min: 0.1, max: 1, message: '抽成比例在0.01~1之间', trigger: ['change','blur'] }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			select_id : {
				type: String,
				required: false
			},
			businesses : {
				type : Array,
				required : true
			}
		},
		watch: {
			select_id: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.clearData()
					this.stallDetail(newVal)
				}
			},
		},
		methods: {
			clearData(){
				this.stallinfo = {
					"id": "",
					"name": "",
					"code": "",
					"contactname": "",
					"telphone": "",
					"address": "",
					"owenbusiness": "",
					"state": "",
					"drawproportion": 0,
				}
				this.editok = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			stallDetail(id){
				if(id !== undefined && id !== null && id != ''){
					getStallDetail({id : id}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.stallinfo = res.data
						}
					})
				}
			},
			saveStalls(){
				this.$refs["stallrule"].validate((valid) => {
					if (valid) {
						if(this.stallinfo.id != null && this.stallinfo.id != ''){  //编辑
							editStall(this.stallinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("修改档口信息成功")
								}else{
									this.$emit("needRefrash",false)
									this.$message.error(res.msg,true)
								}
							})
						}else{ //新增
							addNewStall(this.stallinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.clearData();
									this.$emit("needRefrash",true,false)
									this.$message.success("添加档口信息成功")
								}else{
									this.$emit("needRefrash",false,true)
									this.$message.error(res.msg)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>